import React, { useId } from "react";

/**
 * Subtle diagonal motion-line pattern used behind auth cards.
 * Uses useId so multiple backdrops on the same page never collide on the
 * SVG <pattern> id.
 */
export default function MotionBackdrop({ className = "" }) {
  const patternId = `tm-motion-lines-${useId().replace(/:/g, "")}`;
  return (
    <div
      aria-hidden
      data-testid="motion-backdrop"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    >
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        <defs>
          <pattern id={patternId} width="42" height="42" patternUnits="userSpaceOnUse" patternTransform="rotate(20)">
            <rect width="42" height="42" fill="transparent" />
            <line x1="0" y1="21" x2="42" y2="21" stroke="#0F1115" strokeOpacity="0.04" strokeWidth="1" />
            <line x1="0" y1="0" x2="42" y2="0" stroke="#C9943D" strokeOpacity="0.04" strokeWidth="1" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#${patternId})`} />
      </svg>
      <div className="absolute -left-24 top-24 w-64 h-64 rounded-full" style={{ background: "radial-gradient(closest-side, rgba(201,148,61,0.10), transparent 70%)" }} />
      <div className="absolute -right-32 bottom-16 w-80 h-80 rounded-full" style={{ background: "radial-gradient(closest-side, rgba(20,98,74,0.08), transparent 70%)" }} />
    </div>
  );
}
